import React, { useState, useEffect } from 'react';
import UpperHeader from './Components/Layout/Header/UpperHeader/UpperHeader'
import Footer from './Components/Layout/Footer/Footer/Footer';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import cookie from 'react-cookies'
import String from './Assets/Localization/Local'
import routes from './routes'
import axios from 'axios'
import { API_ENDPOINT } from './AppConfig'
import gsap from 'gsap'
import Preloading from './Components/Preloading/Preloading'
import './App.css'
import { Redirect } from 'react-router';
import { Link } from 'react-router-dom'
// import socketIOClient from "socket.io-client"
// import socket from 'socket.io-client';
// import SocketClient from './socketIo'
import Sockt from "./socketIo";
import Home from './Views/Home/Home';

import firebase from './firebase'
import FirebaseComponent from './FirebaseComponent'


export const LangContext = React.createContext();
export const userCookieContext = React.createContext();

export const userSessionContext = React.createContext();
export const userTokenContext = React.createContext();
export const FormContext = React.createContext();
export const FormContextSignUP = React.createContext();
export const FormContextForgetPass = React.createContext();
export const FormForgetPassConfirmCode = React.createContext();
export const FormNewPassword = React.createContext();
export const FormResetPassword = React.createContext();
export const Notifcations = React.createContext();
export const logoutContext = React.createContext();
export const CompanyData = React.createContext();
// const messaging = firebase.messaging()
const temp = cookie.load('HBLang') === undefined ? "ar" : cookie.load('HBLang');
let token_cookie = cookie.load("HB_token");
let token_sessionStorage = sessionStorage.getItem("HB_token");
let token = `Bearer ${token_cookie ? token_cookie : JSON.parse(token_sessionStorage)}`

const PublicRoute = ({ component: Component, idx, path, exact, name }) => (
  <Route key={idx} path={path} exact={exact} name={name}
    render={props => <Component {...props} />
    }
  />
)


function App() {


  const [flaghandleUserLogout, setFlaghandleUserLogout] = useState(true);

  const [lang, setLang] = useState("ar")
  const [userCookie, setUserCookie] = useState(cookie.load("HBUser"))
  const [userSession, setUserSession] = useState(JSON.parse(sessionStorage.getItem("HBUser")))
  const [userToken, setUserToken] = useState(null);
  const [data, setdata] = useState(null)
  const [openForm, setopenForm] = useState(false)
  const [openFormSignUp, setopenFormSignUp] = useState(false)
  const [openFormForgetPass, setopenFormForgetPass] = useState(false)
  const [openFormConfirmCode, setopenFormConfirmCode] = useState(false)  // modal of confirm code (forget pass)
  const [openFormNewPass, setOpenFormNewPass] = useState(false)
  const [openFormResetPassword, setopenFormResetPassword] = useState(false)
  const [notificationCount, setnotificationCount] = useState(0);
  const [logOutFlag, setLogOut] = useState(false)


  let currentUser_cookie = cookie.load('HBUser');
  let currentUser_session = JSON.parse(sessionStorage.getItem("HBUser"));
  let user = currentUser_session ? currentUser_session : currentUser_cookie

  console.log('logoutFlaglogoutFlag--> ', user)
  Notification.requestPermission().then(function(permission) {
    if (!('permission' in Notification)) {
        Notification.permission = permission;
        console.log('permission--> ', Notification)

    }
    // you got permission !
    }, function(rejection) {
      console.log('permission-->rejection ', rejection)

    // handle rejection here.
    }
);
  useEffect(() => {

    let currentUser_cookie = cookie.load('HBUser');
    let currentUser_session = JSON.parse(sessionStorage.getItem("HBUser"));
    let user = currentUser_session ? currentUser_session : currentUser_cookie


    if (cookie.load('HBLang') === undefined) {
      cookie.save("HBLang", "ar", { path: '/' })
      setLang("ar")
    } else {
      setLang(cookie.load('HBLang'))
    }
    console.log("Token ====>", token, user)
    console.log('www000--> ', window.location)

  }, [])

  useEffect(() => {
    if (cookie.load('HBLang') === undefined) {
      cookie.save("HBLang", "ar", { path: '/' })
      fetch()

    } else {
      fetch()
    }
  }, [lang])

  useEffect(() => {

    let tl = gsap.timeline();

    tl.to('.loading .logo .img1', { duration: 0.2, delay: 0.8, display: 'none', ease: 'Power3.inOut' })
      .to('.loading .logo .img2', { duration: 0, delay: 0.2, display: 'block', ease: 'Power3.inOut' }, 'action1')
      .to('.loading .wavySplash', { duration: 1, delay: 0, height: 0, ease: 'Power3.inOut' }, 'action1')
      .to('.loading .logo .img2', { duration: 1, delay: 0, display: 'none', ease: 'Power3.inOut' })
      .to('.loading', { duration: 1, delay: 0, height: 0, ease: 'Power3.inOut' }, 'action2')
      .to('.AppStyle', { delay: 0, duration: 2, display: 'block', height: '100%', ease: 'Power3.inOut' }, 'action2')

    // messaging.requestPermission().then(() => {
    //   return messaging.getToken()
    // }).then(token => {
    //   console.log('Token Response: ', token)
    //   // addToken(token)

    //   cookie.save("NotificationToken", token, { path: '/' })
    // }).catch((err) => {
    //   console.log('Token error: ', err);
    // })
   
  }, [])
useEffect(()=>{

})
  useEffect(() => {
    // let token_cookie = cookie.load("HB_token");
    // let token_sessionStorage = sessionStorage.getItem("HB_token");
    // if (token_cookie !== undefined && (JSON.stringify(token_sessionStorage) !== "null" || JSON.stringify(token_sessionStorage) !== null)) {
    //   let NotifiToken = cookie.load("NotificationToken")
    //   console.log('NotifiToken-> ', NotifiToken)
    //   addToken(NotifiToken)
    // }
  }, [userToken])

  String.setLanguage(lang);

  // const addToken = (tokenid) => {
  //   let token_cookie = cookie.load("HB_token");
  //   let token_sessionStorage = sessionStorage.getItem("HB_token");
  //   let token = `Bearer ${token_cookie ? token_cookie : JSON.parse(token_sessionStorage)}`

  //   let data = {
  //     token: tokenid,
  //     type: "web"
  //   }
  //   axios.post(`${API_ENDPOINT}/addToken`, data, {
  //     headers: {
  //       'Content-Type': "application/json",
  //       Authorization: token
  //     }
  //   }).then(response => {
  //     console.log('Token Response data==> ', response.data.user)
     
  //   }).catch(error => {
  //     console.log('TToken Response==>error ', error.response)
  //   })
  // }

  const fetch = () => {

    let url = `${API_ENDPOINT}/companies`
    console.log("Result res Take place ===", url, lang)

    axios.get(url,
      { headers: { "Accept-Language": lang, "Content-Type": "application/json" } })
      .then(response => {
        console.log("Result res Take place ===", response.data.data)
        setdata(response.data.data[0])
      })
      .catch(error => {
        console.log("Result Take place Error===", error.response)
      });
  }

  const handleLogOutSocket = (str) => {
    console.log('inside fn----> ', user, str)
    handleUserCookie()
    handleUserSession()
    handleUserToken()
  }

  const handleUserCookie = () => {
    let temp = cookie.load('HBUser');
    console.log('cookie temp-> ', temp)
    setUserCookie(temp);
  }
  const handleUserSession = () => {
    let temp = JSON.parse(sessionStorage.getItem("HBUser"));
    console.log('session temp-> ', temp)

    setUserSession(temp);
  }
  const handleUserToken = (str) => {

    setUserToken(str)
  }
  const ToggleForm = () => {
    setopenForm(!openForm);
    setopenFormForgetPass(false);
  }
  const ToggleForm_signUp = () => {
    setopenFormSignUp(!openFormSignUp);
    // setopenForm(!openForm);
  }
  const ToggleForm_forgetPass = () => {
    setopenFormForgetPass(!openFormForgetPass);
  }
  const ToggleForm_forgetPass_ConfirmCode = () => {
    setopenFormConfirmCode(!openFormConfirmCode);
  }
  const ToggleForm_newPass = () => {
    setOpenFormNewPass(!openFormNewPass)
  }
  const ToggleForm_ResetPassword = () => {
    setopenFormResetPassword(!openFormResetPassword)
  }
  const changeLang = (str) => {
    setLang(str);
    cookie.save("HBLang", str, { path: '/' })
    console.log('lang changed==>> ', str, lang, cookie.load('HBLang'))
  }
  const handelNotificationCount=(data)=>{
    setnotificationCount(data)
  }

  return (

    <LangContext.Provider value={{ lang: lang, changeLang: changeLang }} >

      <userCookieContext.Provider value={{ userCookie: userCookie, handleUserCookie: handleUserCookie }}>
        <userSessionContext.Provider value={{ userSession: userSession, handleUserSession: handleUserSession }}>
          <userTokenContext.Provider value={{ userToken: userToken, handleUserToken: handleUserToken }}>
            <FormContext.Provider value={{ openForm: openForm, ToggleForm: ToggleForm }} >
              <FormContextSignUP.Provider value={{ openFormSignUp: openFormSignUp, ToggleForm_signUp: ToggleForm_signUp }}>
                <FormContextForgetPass.Provider value={{ openFormForgetPass: openFormForgetPass, ToggleForm_forgetPass: ToggleForm_forgetPass }}>
                  <FormForgetPassConfirmCode.Provider value={{ openFormConfirmCode: openFormConfirmCode, ToggleForm_forgetPass_ConfirmCode: ToggleForm_forgetPass_ConfirmCode }} >
                    <FormNewPassword.Provider value={{ openFormNewPass: openFormNewPass, ToggleForm_newPass: ToggleForm_newPass }} >
                      <FormResetPassword.Provider value={{ openFormResetPassword: openFormResetPassword, ToggleForm_ResetPassword: ToggleForm_ResetPassword }} >
                        {/* FormResetPassword */}
                        <Notifcations.Provider value={{ count: notificationCount,handelNotificationCount:handelNotificationCount }}>
                          <logoutContext.Provider value={{ handleLogOutSocket: handleLogOutSocket }}>
                            <CompanyData.Provider value={{ data: data }} >
                              
                              <Preloading />
                              {/* <SocketClient /> */}
                              {user &&
                                <Sockt
                                  serverUrl="https://www.health-book.net:3000/utils"
                                  Logouttopic="LogOut"
                                  Notifytopic="NotificationsCount"
                                  id={user.id}
                                />
                              }
                              <div className="AppStyle" style={{ direction: lang === "ar" ? "rtl" : "ltr", textAlign: lang === "ar" ? "right" : "left" }}>
                                {console.log("socket updated ====>,", notificationCount)}
                                <BrowserRouter>
                                <FirebaseComponent/>
                                  <UpperHeader />
                                  {user === undefined && (window.location.pathname !== '/' || window.location.pathname !== '/HealthBook-Web/Home' || window.location.pathname !== '/HealthBook-Web/about-us' || window.location.pathname !== '/HealthBook-Web/contact-us' || window.location.pathname === "/HealthBook-Web") &&
                                    <Route>
                                      <Redirect to="/HealthBook-Web/Home" />
                                    </Route>
                                  }
                                  {user !== undefined && (window.location.pathname === "/" || window.location.pathname === "/HealthBook-Web" || window.location.pathname === "/HealthBook-Web/") &&
                                    <Route>
                                      <Redirect to="/HealthBook-Web/Home" />
                                    </Route>
                                  }
                                  <Switch >
                                    {
                                      routes.map((route, idx) => {
                                        return (
                                          <PublicRoute path={route.path}
                                            idx={idx}
                                            exact={route.path}
                                            name={route.name}
                                            component={route.component} />
                                        )
                                      },
                                      )}
                                  </Switch>
                                  <Footer />
                                </BrowserRouter>
                              </div>
                            </CompanyData.Provider>
                          </logoutContext.Provider>
                        </Notifcations.Provider>
                      </FormResetPassword.Provider>
                    </FormNewPassword.Provider >
                  </FormForgetPassConfirmCode.Provider>
                </FormContextForgetPass.Provider>
              </FormContextSignUP.Provider>
            </FormContext.Provider>
          </userTokenContext.Provider>
        </userSessionContext.Provider>
      </userCookieContext.Provider>
    </LangContext.Provider >
  );
}

export default App;
